import {
    SEND_CONTRACT_SUCCESS,
    SEND_CONTRACT_ERROR,
    SEND_CONTRACT_START,
    CONTRACT_DOWNLOAD_BY_OP_SUCCESS,
    CONTRACT_DOWNLOAD_BY_OP_ERROR,
    CONTRACT_DOWNLOAD_BY_OP_START,
    SIGN_CONTRACT_SUCCESS,
    SIGN_CONTRACT_ERROR,
    SIGN_CONTRACT_START,
    CONTRACT_VERIFICATION_SUCCESS,
    CONTRACT_VERIFICATION_ERROR,
    CONTRACT_VERIFICATION_START,
    UPLOAD_SING_ADMIN_SUCCESS,
    UPLOAD_SING_ADMIN_ERROR,
    UPLOAD_SING_ADMIN_START,
    PUBLISH_PROFILE_SUCCESS,
    PUBLISH_PROFILE_ERROR,
    PUBLISH_PROFILE_START,
  } from "../Constants/TourContractConstant";
  
  const initialState = {
    sendContract: [],
    loading: false,
    contractDownload: [],
    signContract: [],
    contractVerification: [],
    uploadSignature: [],
    publishProfile: [],
  };
  
  export default function TourContractReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case SEND_CONTRACT_START:
        return {
          ...state,
          loading: true,
        };
      case SEND_CONTRACT_SUCCESS:
        return {
          ...state,
          sendContract: action.payload,
          loading: false,
        };
      case SEND_CONTRACT_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case CONTRACT_DOWNLOAD_BY_OP_START:
        return {
          ...state,
          loading: true,
        };
      case CONTRACT_DOWNLOAD_BY_OP_SUCCESS:
        return {
          ...state,
          contractDownload: action.payload,
          loading: false,
        };
      case CONTRACT_DOWNLOAD_BY_OP_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case SIGN_CONTRACT_START:
        return {
          ...state,
          loading: true,
        };
      case SIGN_CONTRACT_SUCCESS:
        return {
          ...state,
          contractDownload: action.payload,
          loading: false,
        };
      case SIGN_CONTRACT_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case CONTRACT_VERIFICATION_START:
        return {
          ...state,
          loading: true,
        };
      case CONTRACT_VERIFICATION_SUCCESS:
        return {
          ...state,
          contractVerification: action.payload,
          loading: false,
        };
      case CONTRACT_VERIFICATION_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case UPLOAD_SING_ADMIN_START:
        return {
          ...state,
          loading: true,
        };
      case UPLOAD_SING_ADMIN_SUCCESS:
        return {
          ...state,
          uploadSignature: action.payload,
          loading: false,
        };
      case UPLOAD_SING_ADMIN_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case PUBLISH_PROFILE_START:
        return {
          ...state,
          loading: true,
        };
      case PUBLISH_PROFILE_SUCCESS:
        return {
          ...state,
          publishProfile: action.payload,
          loading: false,
        };
      case PUBLISH_PROFILE_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  